// extracted by mini-css-extract-plugin
export var button = "studySpaceList-module--button--e29a6";
export var field = "studySpaceList-module--field--16357";
export var label = "studySpaceList-module--label--9b369";
export var more_info = "studySpaceList-module--more_info--d78f0";
export var space_wrapper = "studySpaceList-module--space_wrapper--b51a7";
export var spaces_list = "studySpaceList-module--spaces_list--0c90a";
export var title = "studySpaceList-module--title--da6b7";